module.exports = __webpack_public_path__ + "img/img_01.89f5c950.png";